/* lib/api/restaurant.js — порт боевого клиента профиля ресторана (frontend/src/lib/api/restaurant.js, 1:1).
 * Профиль = контекст пространства для LLM. Опц. workspaceId → X-Workspace-Id (бизнес-ws без переключения). */

import { apiFetch } from './client.js';

function wsHeaders(workspaceId) {
  if (workspaceId == null) return undefined;
  return { 'X-Workspace-Id': String(workspaceId) };
}

export const getProfile = (workspaceId) =>
  apiFetch('/api/auth/workspace/profile/', { headers: wsHeaders(workspaceId) });

export const updateProfile = (body, workspaceId) =>
  apiFetch('/api/auth/workspace/profile/', { method: 'PATCH', body, headers: wsHeaders(workspaceId) });

// Фото/логотип ресторана (multipart). FormData уходит как есть; wsHeaders добавляет X-Workspace-Id.
export const uploadProfilePhoto = (file, workspaceId) => {
  const fd = new FormData();
  fd.append('photo', file);
  return apiFetch('/api/auth/workspace/profile/photo/', { method: 'POST', body: fd, headers: wsHeaders(workspaceId) });
};

export const deleteProfilePhoto = (workspaceId) =>
  apiFetch('/api/auth/workspace/profile/photo/', { method: 'DELETE', headers: wsHeaders(workspaceId) });

// Юр-реквизиты бизнес-ws (печатные формы). Только бизнес-ws; PATCH — только админ.
export const getRequisites = (workspaceId) =>
  apiFetch('/api/auth/workspace/requisites/', { headers: wsHeaders(workspaceId) });

export const updateRequisites = (body, workspaceId) =>
  apiFetch('/api/auth/workspace/requisites/', { method: 'PATCH', body, headers: wsHeaders(workspaceId) });
